import React, { useState } from 'react';

import BotCustomReportModal from './BotCustomReportModal';

const BotCreateCustomReportButton = (props) => {
  const { sessionId } = props;

  const [showModal, setShowModal] = useState(false);

  const onClickGenerateReportButton = () => {
    setShowModal(true);
  };

  return (
    <>
      <div className="custom-report-button-generate-container">
        <button
          className="custom-report-button-generate"
          type="button"
          onClick={onClickGenerateReportButton}
        >
          Gerar Relatório
        </button>
      </div>
      <div className="custom-report-generate-modal">
        <BotCustomReportModal
          sessionId={sessionId}
          show={showModal}
          setShow={setShowModal}
        />
      </div>
    </>
  );
};

export default BotCreateCustomReportButton;
